export const getCorePlayerImports = async () => {
  return await new Promise((resolve, reject) => {
    if(window.CorePlayer) {
      const {CorePlayerConnection, getVersion, MovieclipElement, calculateEasing} = window.CorePlayer
      resolve({CorePlayerConnection, getVersion, MovieclipElement, calculateEasing})
    }
    else {const interval = setInterval(() => {
      if (window.CorePlayer) {
        const {CorePlayerConnection, getVersion, MovieclipElement, calculateEasing} = window.CorePlayer
        resolve({CorePlayerConnection, getVersion, MovieclipElement, calculateEasing})
        clearInterval(interval)
      };
    }, 100)
    }
  })
}
getCorePlayerImports()
  